(function () {
	'use strict';

	if (typeof IntersectionObserver !== 'undefined') {
		var observer = new IntersectionObserver(function (entries) {
			var delay = 0.5;

			entries.forEach(function (entry, i) {
				var targetValue = parseInt(entry.target.dataset.count);
				var currValue = 0;
				var duration = 3;
				var fps = 30;
				var step = targetValue / (duration * fps);

				if (parseInt(entry.target.innerText) === 0 && entry.isIntersecting) {
					entry.target.innerText = currValue = 0;

				//	setTimeout(function () {
						var interval = setInterval(function () {
							currValue += step;

							if (currValue >= targetValue) {
								requestAnimationFrame(function () {
									entry.target.innerText = targetValue;
								});

								clearInterval(interval);
							}
							else {
								requestAnimationFrame(function () {
									entry.target.innerText = parseInt(currValue);
								});
							}
						}, 1000 / fps);
				//	}, (delay * 1000) * i);
				}
			});
		}, {threshold: .25});

		document.querySelectorAll('[data-count]').forEach(function (el) {
			el.innerText = 0;

			observer.observe(el);
		});
	}
})();
